unable to read source [project]/workspace/frontend/src/core/onResize.ts